import { render, staticRenderFns } from "./PoolBoxes.vue?vue&type=template&id=e37da942&"
import script from "./PoolBoxes.vue?vue&type=script&lang=js&"
export * from "./PoolBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports